<template>
  <input
    v-model="internalValue"
    v-bind="$props"
    :class="$style.field"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @keydown.enter="$e => $emit('submit', $e)"
  />
</template>

<script>
import {
  escape,
  unescape,
  replaceString
} from 'lib/utils/string';

export default {
  name: 'BaseInput',
  props: {
    value: String,
    forceReplace: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        let nextValue = unescape(val);

        if (this.$validate.isNotEmptyArray(this.forceReplace)) {
          nextValue = replaceString(nextValue, this.forceReplace);
        }

        this.internalValue = nextValue;
      },
    },
    internalValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', escape(val), val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .field
    +base-input
</style>
